import { loaderAction, setServicesFormAction } from "../rootReducer";
import growl from "../../lib/growl/growl";
import { setLocalStorage } from "../../helpers/LocalStorage";
import { api } from "../../helpers/api";
import { SERVICES_FORM_INITIAL } from "../initialStateConstant";
import { GetServicesThunk } from "./GetServicesThunk";

export const RemoveReserveThunk = (args) => async (dispatch, getState) => {
    const { user, services } = getState();

    dispatch(loaderAction(true));

    try {
        let formData = new FormData();
        formData.append('user_id', user.id);
        formData.append('hash', user.hash);

        formData.append('reserve_id', args.reserve_id);

        const response = await api({ data: formData, link: 'remove_res' });

        // Если не прошли проверку хеша разлогиниваемся
        if (response.void) {
            setLocalStorage('afp_fitness', '').then(() => window.location.reload());
        }

        if (response.success) {
            // Закрываем форму
            dispatch(setServicesFormAction(SERVICES_FORM_INITIAL));
            // Обновляем данные
            dispatch(GetServicesThunk({ date: services.date }));
        }
        else if (response.error) {
            growl({ type: 'error', message: response.message });
        }
    }
    catch(error) {
        console.log(error);
    }
    finally {
        dispatch(loaderAction(false));
    }

};